import { shallowEqual, useSelector } from 'react-redux';

import { AppendState, UserSession } from '../user.reducer';

const isSignedIn = (s: AppendState) => s.user.session === UserSession.SignedIn;

/**
 * A boolean to be used as a simple flag to
 * indicate if a user is signed in or not
 *
 * ```tsx
 * function Component() {
 *     const isSignedIn = useIsSignedIn();
 *     return (
 *        <div>
 *            {isSignedIn && "Welcome back!"}
 *            {!isSignedIn && "Not signed in!"}
 *        </div>
 *     )
 * }
 * ```
 */
export function useIsSignedIn() {
    return useSelector(isSignedIn, shallowEqual);
}
